const infoCards = [
  {
    icon: "fas fa-plane",
    title: "SERVICE DETAILS",
    body: (
      <>
        <p className="mb-3">The current schedule aligns with existing routes and is designed to support year-round flight times.</p>
        <p className="mb-3">We recommend checking the schedule before your trip to plan your ride with confidence.</p>
        <p className="mb-2">This service is perfect for:</p>
        <ul className="list-disc list-inside space-y-1 text-foreground-700">
          <li>Local residents</li>
          <li>Visitors & tourists</li>
        </ul>
      </>
    ),
  },
  {
    icon: "fas fa-shuttle-van",
    title: "HOW IT WORKS",
    body: (
      <>
        <p className="mb-3">The Airport Shuttle provides convenient service to and from the airport. No special ticket or booking required.</p>
        <p className="mb-2 font-semibold text-foreground-800">Arriving at the airport:</p>
        <ol className="list-decimal list-inside space-y-1 mb-4 text-foreground-700">
          <li>Head through the doors at baggage claim</li>
          <li>Look for the Southern Transit shuttle</li>
          <li>Get off at one of the locations listed on the schedule.</li>
        </ol>
        <p className="mb-2 font-semibold text-foreground-800">Heading to the airport:</p>
        <ol className="list-decimal list-inside space-y-1 text-foreground-700">
          <li>Catch the shuttle at any of the stops above at the indicated times</li>
          <li>Sit back, relax, and arrive without the hassle of parking or traffic.</li>
        </ol>
      </>
    ),
  },
  {
    icon: "fas fa-users",
    title: "WHY RIDE",
    body: (
      <>
        <p className="mb-3">It's simple. Because airport travel is stressful enough already</p>
        <ul className="list-disc list-inside space-y-1 mb-4 text-foreground-700">
          <li>No parking fees</li>
          <li>No searching for rides</li>
          <li>No rental car lines</li>
          <li>Affordable fares</li>
        </ul>
        <p>Riding with Southern Transit saves money, reduces congestion, and supports a more sustainable transportation system for the Trinidad region.</p>
      </>
    ),
  },
];

export default function InfoCards() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {infoCards.map((card) => (
            <div key={card.title} className="text-center">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-primary-500 text-background-50 flex items-center justify-center mx-auto mb-5 md:mb-6">
                <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                  <i className={`${card.icon} text-2xl md:text-3xl`} />
                </span>
              </div>
              <h5 className="font-heading text-base md:text-lg font-bold text-primary-600 tracking-wide mb-4">
                {card.title}
              </h5>
              <div className="text-sm md:text-base text-foreground-700 leading-relaxed text-left">
                {card.body}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}